import { NotificationTypeEnum } from '@acceso/design-system';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useNotificationStore } from '@/stores/notifications';

export interface UseClipboardParams {
  notification?: {
    title: string;
    message?: string;
  };
}

export function useClipboard({ notification }: UseClipboardParams = {}) {
  const { t } = useTranslation();

  const { addNotification } = useNotificationStore();

  const callback = useCallback(
    (text: string) => {
      navigator.clipboard.writeText(text);

      addNotification({
        type: NotificationTypeEnum.SUCCESS,
        title: notification?.title || t('clipboard.message'),
        message: notification?.message,
      });
    },
    [notification, addNotification, t]
  );

  return { callback };
}
